import { Dispatch, SetStateAction } from 'react'
import { InvoiceLineItem } from '../../../../../../store/invoices/invoices.types'

export const useSortLineItems = (
  index: number,
  lines: InvoiceLineItem[],
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
) => {
  return (type: 'UP' | 'DOWN') => {
    switch (type) {
      case 'UP':
        setLines((prevLines) =>
          prevLines?.map((prevLine) => {
            switch (prevLine.id) {
              case lines[index].id:
                return { ...prevLine, position: prevLine.position - 1 }
              case lines[index - 1].id:
                return { ...prevLine, position: prevLine.position + 1 }
              default:
                return prevLine
            }
          })
        )
        break

      case 'DOWN':
        setLines((prevLines) =>
          prevLines?.map((prevLine) => {
            switch (prevLine.id) {
              case lines[index].id:
                return { ...prevLine, position: prevLine.position + 1 }
              case lines[index + 1].id:
                return { ...prevLine, position: prevLine.position - 1 }
              default:
                return prevLine
            }
          })
        )
        break
    }
  }
}

export const useDeleteLineItem = (
  index: number,
  lines: InvoiceLineItem[],
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
) => {
  return () => {
    setLines((prevLines) =>
      prevLines?.map((prevLine, lineIndex) =>
        lineIndex > index
          ? { ...prevLine, position: prevLine.position - 1 }
          : prevLine
      )
    )

    setLines((prevLines) =>
      prevLines?.filter((prevLine) => prevLine.id !== lines[index].id)
    )
  }
}
